<div class="my-3" id="app-dataset-detail-component">
  @if (mzTabResult | async; as result) {
    <app-dataset-card [mzTabResult]="result" [detailView]="true" [showPlots]="true" [showClassifications]="true"
      [showHelpControls]="true" (helpClick)="helpVisible = true" (tourClick)="shepherdService.start()"></app-dataset-card>
    <p-drawer [(visible)]="helpVisible" header="Dataset Detail Help" position="right" class="w-30rem" [modal]="false">
      <div class="flex flex-column gap-3">
        <app-doc-viewer topicId="dataset-detail" mode="summary"></app-doc-viewer>
        <a href="/guide/dataset-detail" target="_blank" rel="noopener noreferrer" class="doc-fulllink">
          Open full documentation ↗
        </a>
      </div>
    </p-drawer>
  } @else {
    <app-error-card
      title="Dataset not available"
      subheader="We could not load the requested dataset"
      [message]="errorMessage"
      feedbackLabel="Contact us"
      [dismissRoute]="['/dataset']"
    ></app-error-card>
  }
</div>
